<template>
  <section>
    <div class="inner">
      <h2 class="Head Head--cl01 Head--mg_md">
        <span class="Head__main Head--md">MELON TV</span><br><span
          class="Head__main_jp"
        >アーカイブ動画
        </span>
      </h2>
    </div>
    <div class="Card__inner Card__archives__inner inner">
      <div v-if="isMobile" class="Card__area Card__archives_area">
        <div
          v-for="(item,key) of listMelonTV"
          :key="key"
        >
          <div v-if="item.first" class="Card__box Card__box--md Card__box--cl_blue" @click="redirectMelontv()">
            <div class="Card__box_play">
              <div class="Arrow__btn Arrow__btn_right Arrow__btn--white" />
            </div>
            <div class="Card__box_label Card__box_label_secondary">
              <div>
                <span class="Card__box_label_class _mg-b8">MELON TV<br></span>
                <span class="Card__box_label_name">一覧ページを見る</span>
              </div>
            </div>
          </div>
          <div
            v-else
            class="Archives__class_box"
            @click="openModalSchedule(item.id)"
          >
            <div
              class="Card__box Card__box--sm"
              :style="parseCssVars(item.master_program_category)"
            >
              <div class="Card__box_label Card__box_label_secondary">
                <div class="Label Label__time Card__box_time_label_secondary">
                  {{ item.time }} 分
                </div>
                <span class="Card__box_label_time">
                  <img
                    :src="item.master_program_category.c_icon_url"
                    alt="icon"
                    class="Card__box_label_icon"
                  >
                  {{ item.learning_time }}
                </span>
                <span class="Card__box_label_class">
                  {{ item.title }}
                </span>
                <span class="Card__box_label_name">
                  <img
                    :src="showAvatar(item.master_instructor)"
                    alt="avatar"
                    class="Card__box_label_avatar"
                  >
                  {{ item.master_instructor.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="Card__area Card__archives_area">
        <div class="Card__box Card__box--md Card__box--cl_blue" @click="redirectMelontv()">
          <div class="Card__box_play">
            <div class="Arrow__btn Arrow__btn_right Arrow__btn--white" />
          </div>
          <div class="Card__box_label Card__box_label_secondary">
            <div>
              <span class="Card__box_label_class _mg-b8">MELON TV<br></span>
              <span class="Card__box_label_name">一覧ページを見る</span>
            </div>
          </div>
        </div>
        <div
          v-for="(item,key) of listMelonTV"
          :key="key"
          class="Card__box_list"
          @click="openModalSchedule(item.id)"
        >
          <div
            class="Card__box Card__box--sm"
            :style="parseCssVars(item.master_program_category)"
          >
            <div class="Card__box_label Card__box_label_secondary">
              <div class="Label Label__time Card__box_time_label_secondary">
                {{ item.time }} 分
              </div>
              <span class="Card__box_label_time">
                <img
                  :src="item.master_program_category.c_icon_url"
                  alt="icon"
                  class="Card__box_label_icon"
                >
                {{ item.learning_time }}
              </span>
              <span class="Card__box_label_class">
                {{ item.title }}
              </span>
              <span class="Card__box_label_name">
                <img
                  :src="showAvatar(item.master_instructor)"
                  alt="avatar"
                  class="Card__box_label_avatar"
                >
                {{ item.master_instructor.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MelonTV from '@/services/melontvService'
import { mapState } from 'vuex'
import { parseCssVars } from '@/helpers/programCategory'
import { convertAvatar } from '@/helpers'

export default {
  data() {
    return {
      listMelonTV: [],
      isMobile: false,
      width: 0,
      height: 0
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin
    })
  },
  watch: {
    isMobile: function() {
      this.getListMelonTV()
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.getListMelonTV()
  },
  updated() {
    this.isMobile
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth
      this.height = window.innerHeight
      if (this.width <= 767) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    redirectMelontv() {
      this.$router.push('/melon-tv')
    },
    openModalSchedule(scheduleId) {
      this.$store.dispatch('modal/openModalMelonTV', scheduleId)
    },
    async getListMelonTV() {
      this.$emit('updateLoadingMelonTV', true)
      if (this.isLogin) {
        const response = await MelonTV.list()
        this.handleCategory(response.data)
        // console.log(response.data)
      }
      this.$emit('updateLoadingMelonTV', false)
    },
    handleCategory(melonTV) {
      // const date = new Date()
      // const today = moment(date).format('YYYY-MM-DD')
      // const compDay = Date.parse(today) + 86400000
      // const yesDay = Date.parse(today) - 43200000
      // const result = []
      // melonTV.forEach(item => {
      //   const format_time_ios = moment(item.date).format('YYYY/MM/DD HH:mm:ss')
      //   if (Date.parse(format_time_ios) >= yesDay &&
      //       Date.parse(format_time_ios) <= compDay) {
      //     result.push(item)
      //   }
      // })
      const item_mobile = {
        'first': true
      }
      if (this.isMobile) {
        melonTV.unshift(item_mobile)
        this.listMelonTV = melonTV.slice(0, 4)
      } else {
        this.listMelonTV = melonTV.slice(0, 7)
      }
    },
    showAvatar(instructor) {
      let url = null
      if (instructor) {
        url = instructor.image_url
      }
      return convertAvatar(url)
    },
    parseCssVars: parseCssVars
  }
}
</script>
